import { CategoryBox, CategoryBoxSize } from '@ori/presentation-components';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import { useCallback } from 'react';

import { useIsMobile } from '../../../hooks';
import { useTranslations } from '../../../hooks/useTranslations';
import { logUserClick } from '../../../utils';
import { BEAUTY_AND_TRENDS, BEAUTY_AND_TRENDS_MOBILE, BEAUTY_AND_TRENDS_MOBILE_LINK } from './constants';
import { BeautyLink, MobileList, Root } from './styles';
import type { BeautyAndTrendsProps } from './types';

export const BeautyAndTrends: FC<BeautyAndTrendsProps> = ({ content }) => {
  const { getTestId } = useTestId();
  const isMobile = useIsMobile();
  const { translations } = useTranslations();

  const analyticsData = useCallback(
    (url?: string) => () => {
      logUserClick(url);
    },
    [],
  );

  if (isMobile) {
    return (
      <Root data-testid={getTestId(BEAUTY_AND_TRENDS_MOBILE)}>
        <MobileList>
          {content?.map((tile) =>
            tile.url && tile.title ? (
              <li key={tile.id}>
                <BeautyLink
                  data-testid={getTestId(BEAUTY_AND_TRENDS_MOBILE_LINK)}
                  href={tile.url}
                  onClick={analyticsData(tile.url)}
                >
                  {tile.title}
                </BeautyLink>
              </li>
            ) : null,
          )}
        </MobileList>
      </Root>
    );
  }

  return (
    <Root data-testid={getTestId(BEAUTY_AND_TRENDS)}>
      {content?.map((item) => (
        <div
          key={item.id}
          onClick={analyticsData(item.url)}
        >
          <CategoryBox
            size={CategoryBoxSize.MEDIUM}
            imageUrl={item.imageUrl}
            title={item.title}
            relativeUrl={item.url ?? ''}
            buttonText={translations.view}
          />
        </div>
      ))}
    </Root>
  );
};
